/** House of Toni volume discount progress (GBP / UK). */
(function () {
  'use strict';

  var TIERS = [
    { min: 2, pct: 0.10 },
    { min: 3, pct: 0.15 },
    { min: 4, pct: 0.20 }
  ];

  function money(cents) {
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents);
    }
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(cents / 100);
  }

  function summarizeCart(cart) {
    var count = 0;
    var subtotal = 0;
    var items = (cart && cart.items) || [];
    items.forEach(function (item) {
      if (item.handle === 'shipping-protection') return;
      count += item.quantity;
      subtotal += (typeof item.original_line_price === 'number' && item.original_line_price > 0) ? item.original_line_price : item.final_line_price;
    });
    return { count: count, subtotal: subtotal };
  }

  function currentState(count, subtotal) {
    var next = null;
    var best = null;
    TIERS.forEach(function (tier) {
      if (count >= tier.min) {
        best = tier;
      } else if (!next && count < tier.min) {
        next = tier;
      }
    });

    var needed = next ? next.min - count : 0;
    return {
      count: count,
      subtotal: subtotal,
      next: next,
      best: best,
      needed: needed,
      savings: best ? Math.round(subtotal * best.pct) : 0
    };
  }

  var HtVolumeBar = class extends HTMLElement {
    connectedCallback() {
      this._onCartChanged = this._onCartChanged.bind(this);
      document.addEventListener('cart:change', this._onCartChanged);

      this._message = this.querySelector('[data-message]');
      this._badge = this.querySelector('[data-badge]');
      this._note = this.querySelector('[data-note]');
      this._chips = Array.prototype.slice.call(this.querySelectorAll('[data-min]'));

      this.render(+this.dataset.count || 0, +this.dataset.subtotal || 0);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:change', this._onCartChanged);
    }

    _onCartChanged(event) {
      var summary = summarizeCart(event.detail.cart);
      this.dataset.count = summary.count;
      this.dataset.subtotal = summary.subtotal;
      this.render(summary.count, summary.subtotal);
    }

    render(count, subtotal) {
      if (!this._message) {
        return;
      }
      var state = currentState(count, subtotal);

      this._chips.forEach(function (chip) {
        chip.classList.toggle('is-active', count >= +chip.getAttribute('data-min'));
      });

      if (state.best) {
        this._badge.hidden = false;
        this._badge.textContent = Math.round(state.best.pct * 100) + '% OFF';
        if (this._note) {
          this._note.hidden = false;
          this._note.textContent = 'You save approximately ' + money(state.savings) + '.';
        }
      } else {
        this._badge.hidden = true;
        if (this._note) this._note.hidden = true;
      }

      var bestPct = state.best ? Math.round(state.best.pct * 100) : 0;
      var nextPct = state.next ? Math.round(state.next.pct * 100) : 0;

      if (state.best && state.next) {
        this._message.textContent = bestPct + '% off unlocked. Add ' + state.needed + ' more item for ' + nextPct + '% off.';
      } else if (state.best) {
        this._message.textContent = 'You have unlocked the maximum 20% volume saving.';
      } else {
        this._message.textContent = 'Add ' + state.needed + ' more ' + (state.needed === 1 ? 'item' : 'items') + ' to unlock 10% off.';
      }
    }
  };

  if (!window.customElements.get('ht-volume-bar')) {
    window.customElements.define('ht-volume-bar', HtVolumeBar);
  }
})();
